/**
 * @file HeadingLevelField.tsx
 * @description Уровень заголовка [Главный H1][Раздела H2][Подраздела H3]
 * (phase19.16 Р2; uiux-design-r2 §4, §10; SB92 — SEO как критерий
 * приёмки): если на странице уже есть главный заголовок в другом блоке —
 * предупреждение «Второй мешает поиску» и кнопка [Сделать H2].
 */

import { Button } from "../../../ui/button";
import { Label } from "../../../ui/label";
import { Segmented } from "../../../site-view/Segmented";
import { secondH1Text, type OtherH1 } from "../../../../lib/site-builder/page-h1";

type Level = 1 | 2 | 3;

const LEVELS = [
  { value: "1", label: "Главный H1" },
  { value: "2", label: "Раздела H2" },
  { value: "3", label: "Подраздела H3" },
];

interface Props {
  level: Level;
  /** Название блока, где уже есть H1; `null` — нет. */
  otherH1: OtherH1 | null;
  onChange: (level: Level) => void;
}

export function HeadingLevelField({ level, otherH1, onChange }: Props) {
  return (
    <div className="flex flex-col gap-1">
      <Label>Уровень</Label>
      <Segmented aria-label="Уровень заголовка" options={LEVELS} value={String(level)} onChange={(v) => onChange(Number(v) as Level)} />
      {level === 1 && otherH1 ? (
        <div role="note" className="flex flex-col items-start gap-2 rounded-md border-l-4 border-warning bg-warning/10 px-2 py-2">
          <p className="type-caption text-on-surface">{secondH1Text(otherH1)}</p>
          <Button variant="outline" size="sm" onClick={() => onChange(2)}>
            Сделать H2
          </Button>
        </div>
      ) : null}
    </div>
  );
}
